// extracted by mini-css-extract-plugin
module.exports = {"fio-suggest":"_6c97079b1b--fio-suggest--PWE_5","fio-item":"_6c97079b1b--fio-item--qMgJu"};